const frTranslations = {
  // header
  home: "Accueil",
  about: "À propos",
  services: "Services",
  contact: "Contact",

  // reserve button
  reserve: "Réservez",
  book: "Réserver",
  bookHer: "Réservez Avec Elle",

  // home page
  welcome: "De la récupération à la performance, nous avons tout ce qu’il vous faut !",
  
  doYouFeel: "Vous sentez-vous...",
  chronicPainProblem: "#Douleur chronique",
  chronicPainDescription: "“Une douleur chronique qui ne disparaît jamais.”",
  mobilityProblem: "#Mobilité limitée",
  mobilityDescription: "“Une mobilité réduite qui vous empêche de bouger comme avant.”",
  injuryProblem: "#Récupération post-blessure",
  injuryDescription: "“Une faiblesse et de la frustration après une blessure.”",
  surgeryProblem: "#Réadaptation post-chirurgie",
  surgeryDescription: "“Des difficultés de guérison après une intervention chirurgicale”",

  takecare: "LogY prend soin de vous",
  ourservice: "Nos services",
  massage: "Massothérapie",
  physicRehab: "Réadaptation physique",
  perforFitness: "Performance & remise en forme",
  chineseMedicine: "Approche en médecine chinoise",

  professional: "Nous sommes des professionnels",
  csepCertified: "Certifié SCPE",
  amqRegistered: "Enregistré à l'AMQ",
  nscaCertified: "Certifié NSCA",
  pnCertified: "Certifié PN",

  weHelpPeople: "Nous avons aidé de nombreuses personnes à se détendre et à récupérer",
  reviewer1: "Yi Ling Ji",
  review1: "« D'habitude, après mes tournois de tennis, je ressens souvent de l'inconfort, surtout au niveau du dos. Mon genou a également été un problème depuis que j’ai commencé ce sport, mais après être allé à la clinique de Ruoyan, je me suis senti beaucoup mieux et soulagé. »",
  reviewer2: "sadra yeganeh",
  review2: "« Ruoyan est une légende dans son domaine. J’y suis allé en boitant, mais je suis ressorti comme si de rien n’était ! »",
  reviewer3: "Chenlu",
  review3: "« Expérience exceptionnelle avec Ruoyan. L'atmosphère était accueillante et apaisante. Ses mains expertes ont fait des merveilles, soulageant les tensions et favorisant une profonde relaxation. J'ai déjà hâte à ma prochaine séance. Je recommande vivement ! »",
  reviewer4: "Mingming Dong",
  review4: "« Massage incroyable avec Ruoyan. Fortement recommandé si vous passez aussi vos journées assis au travail. Mon épaule et le bas de mon dos vont beaucoup mieux après la séance. »",
  reviewer5: "Akshay Shripathi",
  review5: "« Super expérience. J'ai vraiment apprécié le massage. »",
  reviewer6: "Shan Zhong",
  review6: "« Service professionnel d'une massothérapeute ayant une formation en kinésiologie de McGill. Une excellente expérience de relaxation corporelle ! Je reviendrai sans hésiter ! »",

  findUsHere: "Nous trouver",
  addressTitle: "LogY Kinésiologie",
  addressDetail: "1470 Rue Peel suite 820, Montréal, QC, H3A 1T1",
  metroStation: "À côté de la station de métro Peel",
  openHour: "Du lundi au dimanche, de 10h à 20h",
  phoneNumber: "(514) 430-6518",

  // about page
  ourMission: "Notre mission",
  missionStatement: "Nous nous engageons à promouvoir la condition physique comme une habitude de vie et un chemin vers une meilleure santé dans la communauté montréalaise grâce à des programmes personnalisés et fondés sur la recherche. Notre équipe multidisciplinaire composée de physiothérapeutes, kinésiologues, entraîneurs personnels et massothérapeutes intègre harmonieusement la prévention des blessures, la réadaptation et l'amélioration des performances pour accompagner chaque client selon ses objectifs uniques. En favorisant la collaboration entre professionnels, nous établissons de nouvelles normes en matière de soins multidisciplinaires, permettant à chacun d’atteindre son plein potentiel dans un environnement bienveillant et inclusif.",
  meetOurTeam: "Rencontrez notre équipe",
  followUs: "Suivez-nous",

  // service page
  allPricesTaxExcluded: "* Tous les prix sont hors taxes",

  // contact page
  contactUs: "Nous contacter",
  findUs: "Nous Trouver",
  sendMessage: "Envoyer un message",
  firstName: "Prénom",
  lastName: "Nom de famille",
  email: "Courriel",
  phone: "Numéro de téléphone",
  message: "Votre message",
  send: "Envoyer",
  messageSent: "Message envoyé ! Nous vous répondrons bientôt.",

  // footer
  receptionEmail: "logy.reception@gmail.com",

  career: "Carrières",
  wantToJoin: "Vous souhaitez rejoindre LogY ? Envoyez votre CV à :",
  infoEmail: "info@logykinesiologie.ca",

  stayConnect: "Restez Connecté·e",
  stayUpdated: "Restez informé·e de nos dernières promotions, événements et actualités.",
  emailPlaceholder: "Saisissez votre courriel",
  subscribe: "S’abonner",
  subscribeSuccess: "Merci pour votre abonnement !",
  
  homeDescription: "Notre équipe d'experts vous aide à mieux bouger, à vous sentir plus fort et à vivre sans douleur. Que vous vous remettiez d'une blessure ou que vous gériez une douleur chronique, nous vous guiderons à chaque étape dans un espace accueillant et favorable.",
  servicesList: "Kinésiologie • Massage • Réadaptation • Fitness",
  
};
export default frTranslations;
